import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";

var _this = this;

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var navigationIdSeparator = "_-_"; // DONT USE DOTS/COLONS! (they will break querySelector) - Remaining valid characters are: - _

var regExpEscape = function regExpEscape(s) {
  _newArrowCheck(this, _this);

  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}.bind(this); // this function sets ids like id[0][1][4] to each item in the navigationObject
// you can still set custom ids on each item of the navigationObject or give the whole SideNavigation a custom id so ids look like customId[][]...
// if no id is set, generated uuid will be used


function deepGenerateNavObject(navigationObject, id) {
  var _this2 = this;

  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return navigationObject.map(function (item, i) {
    var _this3 = this;

    _newArrowCheck(this, _this2);

    var children = item.children,
        rest = __rest(item, ["children"]);

    var currentPath = "".concat(path).concat(navigationIdSeparator).concat(i);

    var test = function test(index) {
      _newArrowCheck(this, _this3);

      return Array.isArray(currentPath.match("^(".concat(regExpEscape(navigationIdSeparator), "\\d*){").concat(index, "}$")));
    }.bind(this);

    var lvl = 0;

    do {
      lvl += 1;
    } while (!test(lvl));

    return Object.assign(Object.assign({}, rest), {
      id: rest.id || "".concat(id).concat(currentPath),
      path: currentPath,
      key: rest.id || "".concat(id).concat(currentPath),
      item: i,
      level: lvl,
      children: Array.isArray(children) && !!children.length ? deepGenerateNavObject(children, id, currentPath) : undefined
    });
  }.bind(this));
}
/**
 * traverses the provided path and returns an array of navigation items that should be displayed
 */


function cleanupNavigationItemsHeader(navigationItems, selectedPath, activeValue, parentValue) {
  var _this4 = this;

  var level = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1; // cleanup and make a copy of the traversed elements

  var selectedIndex;
  var navigationItemsCleanup = navigationItems.map(function (item, i) {
    _newArrowCheck(this, _this4);

    var targetValue = item.targetValue || "".concat(parentValue, "-").concat(i); // provide a default
    // mark as selected if element is on the path, or if the element is the first element

    var isSelected = selectedPath && selectedPath.length > 0 && selectedPath[0] === targetValue;
    selectedIndex = isSelected ? i : selectedIndex;
    return Object.assign(Object.assign({}, item), {
      targetValue: targetValue,
      isSelected: isSelected,
      isActive: activeValue === targetValue,
      isSelectable: level === 1 || level === 3
    });
  }.bind(this)); // show all children at level 1 or selected items

  navigationItemsCleanup.forEach(function (item) {
    var _this5 = this;

    _newArrowCheck(this, _this4);

    item.children = cleanupNavigationItemsHeader(item.children || [], selectedPath.slice(1), activeValue, item.targetValue, level + 1);
    item.isSelectable = item.isSelectable || item.children.some(function (child) {
      _newArrowCheck(this, _this5);

      return child.isSelectable;
    }.bind(this));
    item.isActive = item.isActive || item.children.some(function (child) {
      _newArrowCheck(this, _this5);

      return child.isActive;
    }.bind(this));
  }.bind(this));
  return navigationItemsCleanup;
}
/**
 * Function to get the possible next selected paths for key interactions depending on the current selected path.
 * In the header, a new state is set on key down.
 */


function getKeyPaths(navigationItems, selectedPath) {
  var _this6 = this;

  var result = {
    up: selectedPath,
    down: selectedPath,
    left: selectedPath,
    right: selectedPath,
    home: selectedPath,
    end: selectedPath
  };

  if (selectedPath.length === 1) {
    var level1Index = navigationItems.findIndex(function (item) {
      _newArrowCheck(this, _this6);

      return item.targetValue === selectedPath[0];
    }.bind(this));
    var level1Item = navigationItems[level1Index];
    var level2Item = level1Item ? level1Item.children.find(function (item) {
      _newArrowCheck(this, _this6);

      return item.isSelectable;
    }.bind(this)) : undefined;
    var level3Item = level2Item ? level2Item.children[0] : undefined; // right opens the next menu level

    result.right = [level1Item && level1Item.targetValue, level2Item && level2Item.targetValue, level3Item && level3Item.targetValue].filter(function (value) {
      _newArrowCheck(this, _this6);

      return value !== undefined;
    }.bind(this));
    var previousIndex = level1Index > 0 ? level1Index - 1 : navigationItems.length - 1;
    result.up = [navigationItems[previousIndex].targetValue];
    var nextIndex = level1Index < navigationItems.length - 1 ? level1Index + 1 : 0;
    result.down = [navigationItems[nextIndex].targetValue];
    result.home = [navigationItems[0].targetValue];
    result.end = [navigationItems[navigationItems.length - 1].targetValue];
  } else if (selectedPath.length === 3) {
    var _level1Index = navigationItems.findIndex(function (item) {
      _newArrowCheck(this, _this6);

      return item.targetValue === selectedPath[0];
    }.bind(this));

    var level2Items = navigationItems[_level1Index].children.filter(function (item) {
      _newArrowCheck(this, _this6);

      return item.isSelectable;
    }.bind(this));

    var level2Index = level2Items.findIndex(function (item) {
      _newArrowCheck(this, _this6);

      return item.targetValue === selectedPath[1];
    }.bind(this));
    var level3Items = level2Items[level2Index].children.filter(function (item) {
      _newArrowCheck(this, _this6);

      return item.isSelectable;
    }.bind(this));
    var level3Index = level3Items.findIndex(function (item) {
      _newArrowCheck(this, _this6);

      return item.targetValue === selectedPath[2];
    }.bind(this)); // up

    if (level3Index > 0) {
      result.up = [selectedPath[0], selectedPath[1], level3Items[level3Index - 1].targetValue];
    } else if (level2Index > 0) {
      var level2IndexNew = level2Index - 1;
      var level3ItemsNew = level2Items[level2IndexNew].children.filter(function (item) {
        _newArrowCheck(this, _this6);

        return item.isSelectable;
      }.bind(this));
      result.up = [selectedPath[0], level2Items[level2IndexNew].targetValue, level3ItemsNew[level3ItemsNew.length - 1].targetValue];
    } else {
      result.up = [selectedPath[0]];
    } // down


    if (level3Index < level3Items.length - 1) {
      result.down = [selectedPath[0], selectedPath[1], level3Items[level3Index + 1].targetValue];
    } else if (level2Index < level2Items.length - 1) {
      var _level2IndexNew = level2Index + 1;

      var _level3ItemsNew = level2Items[_level2IndexNew].children.filter(function (item) {
        _newArrowCheck(this, _this6);

        return item.isSelectable;
      }.bind(this));

      result.down = [selectedPath[0], level2Items[_level2IndexNew].targetValue, _level3ItemsNew[0].targetValue];
    } else {
      var _level2IndexNew2 = 0;

      var _level3ItemsNew2 = level2Items[_level2IndexNew2].children.filter(function (item) {
        _newArrowCheck(this, _this6);

        return item.isSelectable;
      }.bind(this));

      result.down = [selectedPath[0], level2Items[_level2IndexNew2].targetValue, _level3ItemsNew2[0].targetValue];
    } // left


    if (level2Index > 0) {
      var _level2IndexNew3 = level2Index - 1;

      var _level3ItemsNew3 = level2Items[_level2IndexNew3].children.filter(function (item) {
        _newArrowCheck(this, _this6);

        return item.isSelectable;
      }.bind(this));

      result.left = [selectedPath[0], level2Items[_level2IndexNew3].targetValue, _level3ItemsNew3[0].targetValue];
    } else {
      result.left = [selectedPath[0]];
    } // right


    if (level2Index < level2Items.length - 1) {
      var _level2IndexNew4 = level2Index + 1;

      var _level3ItemsNew4 = level2Items[_level2IndexNew4].children.filter(function (item) {
        _newArrowCheck(this, _this6);

        return item.isSelectable;
      }.bind(this));

      result.right = [selectedPath[0], level2Items[_level2IndexNew4].targetValue, _level3ItemsNew4[0].targetValue];
    } else {
      var _level2IndexNew5 = 0;

      var _level3ItemsNew5 = level2Items[_level2IndexNew5].children.filter(function (item) {
        _newArrowCheck(this, _this6);

        return item.isSelectable;
      }.bind(this));

      result.right = [selectedPath[0], level2Items[_level2IndexNew5].targetValue, _level3ItemsNew5[0].targetValue];
    } // home


    var level2IndexHome = 0;
    var level3ItemsHome = level2Items[level2IndexHome].children.filter(function (item) {
      _newArrowCheck(this, _this6);

      return item.isSelectable;
    }.bind(this));
    result.home = [selectedPath[0], level2Items[level2IndexHome].targetValue, level3ItemsHome[0].targetValue]; // end

    var level2IndexEnd = level2Items.length - 1;
    var level3ItemsEnd = level2Items[level2IndexEnd].children.filter(function (item) {
      _newArrowCheck(this, _this6);

      return item.isSelectable;
    }.bind(this));
    result.end = [selectedPath[0], level2Items[level2IndexEnd].targetValue, level3ItemsEnd[level3ItemsEnd.length - 1].targetValue];
  }

  return result;
} // this flattens the navigationObject to one array - used to easily filter for open or active items


function deepFlatten(navigationObject) {
  var _this7 = this;

  return navigationObject ? navigationObject.reduce(function (result, current) {
    var _this8 = this;

    _newArrowCheck(this, _this7);

    return [].concat(_toConsumableArray(result), [current], _toConsumableArray(deepFlatten(current.children))).filter(function (item) {
      _newArrowCheck(this, _this8);

      return item !== undefined;
    }.bind(this));
  }.bind(this), []) : [];
}

function getRootIndex(path) {
  return parseInt(path[path.indexOf(navigationIdSeparator) + navigationIdSeparator.length], 10);
}

function expandAll(navigationObject) {
  var _this9 = this;

  var nonCollapsible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return navigationObject.map(function (item) {
    _newArrowCheck(this, _this9);

    return item.children ? Object.assign(Object.assign({}, item), {
      nonCollapsible: nonCollapsible,
      expanded: true,
      children: expandAll(item.children)
    }) : item;
  }.bind(this));
}

export { deepGenerateNavObject, cleanupNavigationItemsHeader, getKeyPaths, deepFlatten, getRootIndex, expandAll };